import { WidgetType } from "@codemirror/view";

function normalizeCell(cell) {
    return cell
        .replace(/\\(?:toprule|midrule|bottomrule|hline)\b/g, "")
        .replace(/\\(?:bf|it|tt|em)\b/g, "")
        .replace(/[{}]/g, "")
        .trim();
}

function parseTabularContent(content) {
    return content
        .split(/\\\\/)
        .map((row) => row.trim())
        .filter(Boolean)
        .map((row) =>
            row
                .split("&")
                .map((cell) => normalizeCell(cell))
                .filter((cell, index, cells) => !(cells.length === 1 && cell === "")),
        )
        .filter((cells) => cells.length > 0);
}

export class TabularWidget extends WidgetType {
    constructor(content) {
        super();
        this.content = content;
    }

    toDOM() {
        const element = document.createElement("div");
        element.classList.add("ol-cm-tabular");

        this.renderTable(element);

        return element;
    }

    eq(widget) {
        return this.content === widget.content;
    }

    updateDOM(element) {
        this.renderTable(element);
        return true;
    }

    coordsAt(element) {
        return element.getBoundingClientRect();
    }

    renderTable(element) {
        element.textContent = "";

        const rows = parseTabularContent(this.content || "");
        if (rows.length === 0) {
            const box = document.createElement("div");
            box.className = "ol-cm-figure-box";
            box.textContent = this.content || "tabular";
            element.appendChild(box);
            return;
        }

        const table = document.createElement("table");
        const body = document.createElement("tbody");

        rows.forEach((cells) => {
            const tr = document.createElement("tr");
            cells.forEach((cell) => {
                const td = document.createElement("td");
                td.textContent = cell || " ";
                tr.appendChild(td);
            });
            body.appendChild(tr);
        });

        table.appendChild(body);
        element.appendChild(table);
    }
}
